import Service from '../../services'

const TestModule = {
  namespaced: true,
  state: {
    specimenType: [],
    testType: [],
    setTest: [],
    selectedSpecimenType: [],
    lstSetTest: [],
  },
  mutations: {
    SET_SPECIMEN_TYPE: (state, data) => {
      state.specimenType = data
    },
    SET_TEST_TYPE: (state, data) => {
      state.testType = data
    },
    SET_SET_TEST: (state, data) => {
      state.setTest = data
    },
    SET_SELECTED_SPECIMEN_TYPE: (state, data) => {
      state.selectedSpecimenType = data
    },
  },
  actions: {
    setSpecimenType({ commit }) {
      Service.test.getAllSpecimenTypes().then((res) => {
        commit('SET_SPECIMEN_TYPE', res)
      })
    },
    setTestType({ commit }) {
      Service.test.getAllTestTypes().then((res) => {
        commit('SET_TEST_TYPE', res)
      })
    },
    setSetTest({ commit }) {
      Service.test.getAllSetTests().then((res) => {
        commit('SET_SET_TEST', res)
      })
    },
    setSelectedSpecimenType({ commit }, payload) {
      return Service.test.getSpecimenType(payload).then((res) => {
        commit('SET_SELECTED_SPECIMEN_TYPE', res)
      })
    },
    setAfterDelete({ commit, state }) {
      // console.log('5555');
      for (let x = 0; x < state.testType.length; x++) {
        for (let y = 0; y < state.testType[x].test.length; y++) {
          for (let z = 0; z < state.selectedSpecimenType.length; z++) {
            for (
              let a = 0;
              a < state.selectedSpecimenType[z].test.length;
              a++
            ) {
              if (
                state.selectedSpecimenType[z].test[a].id ==
                state.testType[x].test[y].id
              ) {
                state.testType[x].test[y].splice(y, 1)
              }
            }
          }
        }
      }
    },
    getMachine({ commit }) {
      return Service.test.getMachine()
    },
    getTestsBySpecie({ commit }, specieId) {
      return Service.test.getTestsBySpecie(specieId)
    },
    getSetTestsBySpecie({ commit }, specieId) {
      return Service.test.getSetTestsBySpecie(specieId)
    },
    getTestRefRangeList({ commit }, testId) {
      return Service.test.getTestRefRangeList(testId)
    },
    getSubTestRefRangeList({ commit }, subTestId) {
      return Service.test.getSubTestRefRangeList(subTestId)
    },
    async deleteCustomRefRange({ commit }, { id, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password })

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token
        return Service.test.deleteCustomRefRange(id, token)
      } else {
        throw { message: 'password incorrect' }
      }
    },
    async updateRefRangeList({ commit }, { payload, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password })

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token
        return Service.test.updateRefRangeList(payload, token)
      } else {
        throw { message: 'password incorrect' }
      }
    },
    getSetTestById({ commit }, id) {
      return Service.test.getSetTestById(id)
    },
    async deleteSetTest({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data)

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token
        return Service.test.deleteSetTest(data.id, token)
      } else {
        throw { message: 'password incorrect' }
      }
    },
  },
  getters: {
    getSpecimenType(state) {
      return state.specimenType
    },
    getTestType(state) {
      return state.testType
    },
    getSetTest(state) {
      return state.setTest
    },
    getSelectedSpecimenTypes(state) {
      return state.selectedSpecimenType
    },
  },
}
export default TestModule
